import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/* Tailwind class merger. Lives on its own (re-exported by lib/utils) so the
   UI primitives that load with every page don't drag in lib/utils' date
   helpers and moment-timezone. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
